import {$hostAuth} from "../http";

class ProductsService{
    async getAll(){
        const {data} = await $hostAuth.get(`/api/products/all`);
        return data
    }

    async getAllSub(subId){
        const {data} = await $hostAuth.get(`/api/products/all/subd?subId=${subId}`);
        return data
    }

    async update(dataReq){
        const {data} = await $hostAuth.put(`/api/products`, dataReq)
        return data
    }

    async create(dataReq){
        const {data} = await $hostAuth.post(`/api/products`, dataReq)
        return data
    }

    async updateOrder(ids){
        const {data} = await $hostAuth.post(`/api/products/order`, {ids});
        return data
    }

    async delete(id){
        const {data} = await $hostAuth.delete(`/api/products`, {params: {id}});
        return data
    }

}

export default new ProductsService()